import { Reducer } from 'redux';
import { ServicesState } from 'models';
import { ServicesActionTypes } from './action-types';
import { ActionTypes } from '../helpers';

const initialState: ServicesState = {
  selectedResource: null,
  slotDuration: null,
  serviceId: null,
};

export const reducer: Reducer<ServicesState, ActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ServicesActionTypes.SET_SERVICE_RESOURCE:
      return {
        selectedResource: action.payload.resource,
        slotDuration: action.payload.slotDuration || null,
        serviceId: action.payload.serviceId,
      };
    default:
      return state;
  }
};
